import { render, staticRenderFns } from "./LocalBankToUpSuccess.vue?vue&type=template&id=4044b707&scoped=true&"
import script from "./LocalBankToUpSuccess.vue?vue&type=script&lang=js&"
export * from "./LocalBankToUpSuccess.vue?vue&type=script&lang=js&"
import style0 from "./LocalBankToUpSuccess.vue?vue&type=style&index=0&id=4044b707&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4044b707",
  null
  
)

export default component.exports